var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.loader},[_vm._m(0)]),_c('div',{class:_vm.result},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 text-center mt-5"},[_c('a',{staticClass:"btn btn-link btn-lg",staticStyle:{"font-size":"30px"},attrs:{"href":""}},[_c('i',{staticClass:"fas fa-spinner"})])])
}]

export { render, staticRenderFns }